export enum SerpFeatureSet2Gq {
  none = 0,
  related_searches = 1,
  scholarly_articles = 2,
  shopping = 4,
  short_videos = 8,
  stocks_box = 16,
  top_sights = 32,
  top_stories = 64,
  twitter = 128,
  video = 256,
  visual_stories = 512,
}
